import React, { useEffect, useState,useContext } from "react";
import axiosInstance from "../../ReusableComponents/Axios";
import DropdownValues from "../../Student/Reusablecomponents/DropDownValues";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import DataTable from "../../Student/Reusablecomponents/DataTable/DataTable";
import {LoadContext} from "../../ReusableComponents/LoadingContex";
const LiveAssessmentDetails = () => {
 const { SetLoad } = useContext(LoadContext);
    const [INSTOptions, SetINSTOptions] = useState([]);
    const [SINST, SetSINST] = useState();
    const [ADOptions, SetADOptions] = useState([]);
    const [SAD, SetSAD] = useState([]);
    const [SocietyOptions, SetSocietyOptions] = useState([]);
    const [SSociety, SetSSociety] = useState([]);

    const [FullData, SetFullData] = useState([]);
    const [APCounts, SetAPCounts] = useState([]);
    const GetInstitutes = async () => {
        SetLoad(true);
        try {
            const res = await axiosInstance.get(`/NCLAdmin/GetAssessmentDetailsbyInstitute`);
            const uniqueInstitutes = Array.from(
                new Map(res.data.map((IN) => [IN?.instituteId, { display: IN?.instituteName, value: IN?.instituteId }])).values()
            );
            SetINSTOptions(uniqueInstitutes);
            SetSINST(uniqueInstitutes?.[0]?.value);

            const Society = res.data.filter((RIN) => RIN?.instituteId === uniqueInstitutes?.[0]?.value && RIN?.societyId !== 0)
                .map((S) => ({ display: S?.societyCode, value: S?.societyId }));
            SetSocietyOptions(Society);
            SetSSociety(Society?.[0]?.value);

            const uniqueDates = res.data.filter((RIN) => RIN?.instituteId === uniqueInstitutes?.[0]?.value && RIN?.societyId === (Society?.[0]?.value || 0))
                .map((AD) => ({ display: `${AD?.assessmentName}, ${AD?.examAvailabilityStartDate}`, value: AD?.contestCreationId }))
            SetADOptions(uniqueDates);
            SetSAD(uniqueDates?.[0]?.value);
            SetFullData(res.data);
            GetCounts(res.data,uniqueDates?.[0]?.value,Society?.[0]?.value || 0);
        }
        catch (err) { console.log(err) }
    }
    useEffect(() => { GetInstitutes(); }, [])
    const InstituteChange = (e) => {
        SetSINST(e);
        const Society = FullData.filter((RIN) => RIN?.instituteId === parseInt(e) && RIN?.societyId !== 0)
            .map((S) => ({ display: S?.societyCode, value: S?.societyId }));
        SetSocietyOptions(Society);
        SetSSociety(Society?.[0]?.value);
        const uniqueDates = FullData.filter((RIN) => RIN?.instituteId === parseInt(e) && RIN?.societyId === (Society?.[0]?.value || 0))
            .map((AD) => ({ display: `${AD?.assessmentName} ${AD?.examAvailabilityStartDate}`, value: AD?.contestCreationId }))
        SetADOptions(uniqueDates);
        SetSAD(uniqueDates?.[0]?.value);
    }
    const SocietyChange = (e) => {
        SetSSociety(e);
        const uniqueDates = FullData.filter((RIN) => RIN?.instituteId === parseInt(SINST) && RIN?.societyId === (parseInt(e) || 0))
            .map((AD) => ({ display: `${AD?.assessmentName} ${AD?.examAvailabilityStartDate}`, value: AD?.contestCreationId }))
        SetADOptions(uniqueDates);
        SetSAD(uniqueDates?.[0]?.value);
    }
    const ASSDatesChange = (e) => {
        SetSAD(e);
    }

    const GetCounts = (Data,C,SS) => {
         SetLoad(true);
        const SelectData = Data?.filter((SD) => SD?.contestCreationId === parseInt(C) && SD?.societyId === (parseInt(SS) || 0))?.[0];
        GetAssessmentsParticipationcount(SelectData?.instituteId, SelectData?.contestCreationId, SelectData?.assessmentType, SelectData?.assessmentTypeNo,SelectData?.societyId);
    }
    const GetAssessmentsParticipationcount = async (SIN, CCID, AType, ATNo,SID) => {
        await axios.get(process.env.REACT_APP_API_BASE_URL +
            `/InstitutionAdmin/GetSchoolwiseAsstParticipationbyInstitute?InstituteId=${SIN}&AssessmentType=${AType}&AssessmentTypeNo=${ATNo}&ContestcreationId=${CCID}&SocietyId=${SID}`,
            { headers: { XApiKey: process.env.REACT_APP_XApiKey } })
            .then((res) => {
                const Totals = res.data.reduce(
                    (acc, item) => {
                        acc.participationCount += item.participationCount;
                        acc.registeredCount += item.registeredCount;
                        return acc;
                    },
                    {
                        participationCount: 0,
                        registeredCount: 0
                    }
                );
                const Total = { schoolName: "Total", ...Totals }
                SetAPCounts([Total, ...res.data]);
                SetLoad(false);
            })
            .catch((err) => { console.log(err);SetLoad(false); });
    }
    const columns = [
        { name: "School ID", sortable: true, selector: "schoolLoginId", },
        { name: "School Name", sortable: true, selector: "schoolName", },
        { name: "Registered Count", selector: "registeredCount", sortable: true, },
        { name: "Participation Count", selector: "participationCount", sortable: true, },
    ];
    return (
        <>
            <div className="InputFIlters">
                <label>Live Assessment Participation Input</label>
                <br />
                <Row>
                    <Col>
                        <DropdownValues className={`w-100 NCLDropdown`} options={INSTOptions} selectoption={SINST}
                            labelname={<div className="DropdownHeader"> Institute <span>*</span> </div>} onChange={(e) => InstituteChange(e.target.value)} />
                    </Col>
                    {SocietyOptions?.length > 0 && <Col>
                        <DropdownValues className={`w-100 NCLDropdown`} options={SocietyOptions} selectoption={SSociety}
                            labelname={<div className="DropdownHeader">Society <span>*</span> </div>} onChange={(e) => SocietyChange(e.target.value)} />
                    </Col>}
                    <Col>
                        <DropdownValues className={`w-100 NCLDropdown`} options={ADOptions} selectoption={SAD}
                            labelname={<div className="DropdownHeader"> Assessment & Dates <span>*</span> </div>} onChange={(e) => ASSDatesChange(e.target.value)} />
                    </Col>
                    <Col><button className="Buttons m-3" onClick={()=>GetCounts(FullData,SAD,SSociety)} >Go</button></Col>
                </Row>
            </div>
            <DataTable className="Card NCLDataTable mt-2" data={APCounts} columns={columns}
                ShowPagination={true} ShowPagecount={true} Dropdownvalues={["10", "25", "50", "100"]} />
        </>
    )
}
export default LiveAssessmentDetails;